import { store } from "@store";
import { setAppConfigsApi } from "@services/api";
import DeviceInfo from "react-native-device-info";
import messaging from "@react-native-firebase/messaging";
import { checkNotifications } from "react-native-permissions";

const setAppConfigs = async () => {
  const { auth } = store.getState();
  if (!auth?.user?.user_id) return;
  try {
    let status = "denied";
    try {
      const { status: s } = await checkNotifications();
      status = s;
    } catch {}
    const fcm_token = await messaging().getToken();
    await setAppConfigsApi(
      DeviceInfo.getVersion(),
      DeviceInfo.getBuildNumber(),
      fcm_token,
      status,
    );
  } catch (e) {
    console.log(e);
  }
};

export default setAppConfigs;
